import { laborRemotePersistenceDisabled } from "@/lib/labor/laborEnv";
import { FALLBACK_LABOR_HEARTBEAT_INTERVAL_MS, FALLBACK_LABOR_IDLE_TIMEOUT_MS } from "@/lib/labor/useLaborSession";

export {
  type LaborClockMenuState,
  laborPageKeysEquivalent,
  formatLaborLocationLabel,
  clampQcLaborPayloadSignalsActiveOnOtherPage,
  clampQcInspectionListShouldDisableOpenJobForSlug,
  laborClockMenuStateFromActiveSessionPayload,
  clampQcLaborPageKeyForJobSlug,
  clampQcLaborExpectedPageFromPathname,
  effectiveLaborClockMenuStateForUserMenu,
} from "./clampQcLaborClockState";

export { FALLBACK_LABOR_HEARTBEAT_INTERVAL_MS, FALLBACK_LABOR_IDLE_TIMEOUT_MS };

/** One-shot message read by the inspection list after a failed job open + redirect. */
export const CLAMPQC_LABOR_OPEN_FLASH_STORAGE_KEY = "clampqc_open_job_labor_flash_message";

/**
 * When true, the job workspace does not call labor APIs (no Supabase persistence). Default in Vite dev so local runs
 * can fake timers and intervals. Set `VITE_CLAMP_QC_USE_SUPABASE_LABOR=true` in `ui/.env` to exercise real labor against
 * your dev API and database.
 */
export function clampQcLaborRemotePersistenceDisabled(): boolean {
  return laborRemotePersistenceDisabled("clampqc");
}
